import type { NavigationGuardReturn, RouteLocationNormalized } from 'vue-router';

import { useAuthStore } from '@/entities/auth';
import { useToast } from '@/shared/lib/toast';

/**
 * Проверяет, что организации доступен хотя бы один из модулей meta.modules.
 */
export const moduleGuard = (to: RouteLocationNormalized, from: RouteLocationNormalized): NavigationGuardReturn => {
  const modules = to.meta.modules;

  if (!modules || modules.length === 0) {
    return true;
  }

  const authStore = useAuthStore();
  const hasModule = modules.some((module) => authStore.hasModule(module));

  if (!hasModule) {
    const toast = useToast();
    toast.error('Раздел недоступен для вашей организации');

    if (from.name) {
      return { name: from.name, params: from.params, query: from.query };
    }

    return { name: 'home.index' };
  }

  return true;
};
